module.exports = __webpack_public_path__ + "static/assets/a662913c45d963c9548f434c825634b7.png";